"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.beerCategories = exports.drinkType = exports.DrinkSchema = exports.DrinkInitialized = void 0;
const joi_1 = __importDefault(require("joi"));
const drinkTypes_1 = require("../data/dropdownData/drinkTypes");
const joiMessages_1 = require("../data/joiMessages");
const validations_1 = require("../data/validations");
exports.DrinkInitialized = {
    name: '',
    description: '',
    canSelectMl: false,
    discountTimes: [],
    pricePerMl: 2,
    minimumSelectMl: 100,
    mlPriceContent: 0,
    price: 0,
    discountPrice: 0,
    maximumSelectMl: 5000,
    price330Ml: 1000,
    type: '',
    drinkType: '',
    taste: '',
    foodPair: '',
    country: '',
    alc: '0',
    colorOne: '',
    colorTwo: '',
    brewery: '',
    image: null,
    imageClearLink: null,
    imageLink: null,
    imageLinks: null,
    isAlcoholic: false,
};
exports.DrinkSchema = joi_1.default.object({
    name: joi_1.default.string()
        .optional()
        .allow('')
        .max(50)
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Name', isRequired: true }),
    }),
    description: joi_1.default.string()
        .optional()
        .allow('')
        // .max(50)
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Description' }),
    }),
    canSelectMl: joi_1.default.boolean().optional().default(false),
    isAlcoholic: joi_1.default.boolean().optional().default(false),
    mlPriceContent: joi_1.default.number()
        .min(0)
        .max(1500)
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Ml price content' }),
    }),
    price: joi_1.default.number()
        .min(0)
        .max(99000)
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Price' }),
    }),
    discountPrice: joi_1.default.number()
        .optional()
        .allow('')
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Discount price' }),
    }),
    pricePerMl: joi_1.default.number()
        .min(0)
        .max(1000)
        .optional()
        .allow('')
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Price per ml' }),
    }),
    price330Ml: joi_1.default.number()
        .min(0)
        .max(9999)
        .optional()
        .allow('')
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Price per 330 ml' }),
    }),
    minimumSelectMl: joi_1.default.number()
        .min(0)
        .max(1000)
        .optional()
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Minimum select ml' }),
    }),
    maximumSelectMl: joi_1.default.number()
        .min(50)
        .max(9000)
        .optional()
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Maximum select ml' }),
    }),
    type: joi_1.default.string()
        .optional()
        .allow('')
        .max(50)
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Type' }),
    }),
    drinkType: joi_1.default.string()
        .optional()
        .valid(...drinkTypes_1.drinkTypes)
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Drink type', isRequired: true }),
    }),
    taste: joi_1.default.string()
        .optional()
        .allow('')
        .max(100)
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Taste' }),
    }),
    foodPair: joi_1.default.string()
        .optional()
        .allow('')
        .max(100)
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Food pair' }),
    }),
    country: joi_1.default.string()
        .optional()
        .allow('')
        .max(100)
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Country' }),
    }),
    alc: joi_1.default.string()
        .pattern(validations_1.percentageRegex)
        .allow('')
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({
            name: 'Alcohol',
            patternText: 'This percentage is on a wrong format. Make sure to use "." instead of ","',
        }),
    }),
    colorOne: joi_1.default.string()
        .allow('')
        .pattern(validations_1.hexRegex)
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({
            name: 'Color one',
            patternText: 'Value has to be on a hexadecimal value. ',
        }),
    }),
    colorTwo: joi_1.default.string()
        .allow('')
        .pattern(validations_1.hexRegex)
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({
            name: 'Color two',
            patternText: 'Value has to be on a hexadecimal value. ',
        }),
    }),
    brewery: joi_1.default.string()
        .allow('')
        .max(40)
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Brewery' }),
    }),
    image: joi_1.default.any().optional(),
    imageClearLink: joi_1.default.any().optional(),
    imageLink: joi_1.default.any().optional(),
    imageLinks: joi_1.default.any().optional(),
    discountTimes: joi_1.default.any().optional(),
    modal: joi_1.default.any().optional(),
    id: joi_1.default.any().optional(),
});
exports.drinkType = [
    'Beer',
    'Cocktail',
    'Coffee',
    'Whiskey',
    'Wine',
    'Other',
    'Soda',
];
exports.beerCategories = [
    'Amber Ale',
    'Belgian Ale',
    'Blonde Ale',
    'Bock',
    'Brown Ale',
    'Cream Ale',
    'IPA',
    'Imperial Stout',
    'Lager',
    'Pale Ale',
    'Pilsner',
    'Porter',
    'Red Ale',
    'Saison',
    'Scotch Ale',
    'Sour Beer',
    'Stout',
    'Wheat Beer',
];
